import { Flex, SelectField } from "@aws-amplify/ui-react";
import { useState, useEffect } from "react";
import { getFileList } from "../../lib/StorageUtil";

const TOP_DIR = "public/内部データ/";

const TraceForPlottingSelecter = ({
  location,
  onChange,
}) => {
  // 選択している日時
  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(0);
  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);

  // フォルダリスト
  const [yearMounthFolders, setYearMounthFolders] = useState([]);
  const [dayFolders, setDayFolders] = useState([]);
  const [hourFolders, setHourFolders] = useState([]);
  const [traceFiles, setTraceFiles] = useState([]);

  // オプションリスト
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [dayOptions, setDayOptions] = useState([]);
  const [hourOptions, setHourOptions] = useState([]);
  const [minuteOptions, setMinuteOptions] = useState([]);

  // 現在選択しているトレースファイル
  const [selectedTraceFile, setSelectedTraceFile] = useState("");

  // 初期化
  const init = async () => {
    console.warn("init");
    
    const prefix = `${TOP_DIR}${location}/trace/`;

    const list = await getFileList(prefix);

    setYearMounthFolders(list);
  }

  // 選択肢更新
  const updateYearOptions = async (forders) => {
    const options = [];

    for (const f of forders) {
      const year = parseInt(f.name.substr(0, 4));

      // 重複チェック
      if (options.indexOf(year) === -1) {
        options.push(year);
      }
    }

    setYearOptions(options);
    setYear((prev) => {
      return options.includes(prev) ? prev : options.at(-1);
    });
  }
  const updateMonthOptions = async (year, forders) => {
    const options = [];

    for (const f of forders) {
      const year_num = parseInt(f.name.substr(0, 4));
      const num = parseInt(f.name.substr(4, 7));

      // 年が一致するものだけを抽出
      if (year_num !== year) {
        continue;
      }

      // 重複チェック
      if (options.indexOf(num) === -1) {
        options.push(num);
      }
    }

    setMonthOptions(options);
    setMonth((prev) => {
      return options.includes(prev) ? prev : options.at(-1);
    });
  }
  const updateDayOptions = async (forders) => {
    const options = [];

    for (const f of forders) {
      options.push(parseInt(f.name))
    }

    setDayOptions(options);

    setDay((prev) => {
      return options.includes(prev) ? prev : options.at(-1);
    });
  }
  const updateHourOptions = async (forders) => {
    // 時間の選択肢を更新
    const options = [];

    for (const f of forders) {
      options.push(parseInt(f.name));
    }

    setHourOptions(options);

    setHour((prev) => {
      // 選択肢に存在しない場合は最後の選択肢を選択
      return options.includes(prev) ? prev : options.at(-1);
    });
  }
  const updateMinuteOptions = async (file) => {
    // 分の選択肢を更新
    const options = [];

    for (const f of file) {
      // name: "yscc_trace_20241231_2350.csv"
      const opt = f.name.split("_").at(-1).substr(2, 2);
      options.push(parseInt(opt));
    }

    setMinuteOptions(options);

    setMinute((prev) => {
      return options.includes(prev) ? prev : options.at(-1);
    });
  }

  const getDayFolders = async (year, month, folders) => {
    // 年月に一致するフォルダを取得
    const folder = folders.find((f) => {
      const y = parseInt(f.name.substr(0, 4));
      const m = parseInt(f.name.substr(4, 7));

      return y === year && m === month;
    });

    const key = folder == null ? folders.a(-1).searchKey : folder.searchKey;

    setDayFolders(await getFileList(key));
  }

  const getHourFolders = async (day, folders) => {
    const folder = folders.find((f) => {
      return parseInt(f.name) === day;
    });

    const key = folder == null ? folders.at(-1).searchKey : folder.searchKey;

    setHourFolders(await getFileList(key));
  }

  const getTraceFiles = async (minute, folders) => {
    console.warn("getTraceFiles");

    const folder = folders.find((f) => {
      return parseInt(f.name) === minute;
    });

    const key = folder == null ? folders.at(-1).searchKey : folder.searchKey;

    const files = await getFileList(key);

    // 必要なファイルのみに絞る
    const traceFiles = files.filter((f) => {
      // _ の数が 3つのものだけを抽出
      return f.name.split("_").length === 4;
    });

    setTraceFiles(traceFiles);
  }

  useEffect(() => {
    init()
  }, [location]);

  useEffect(() => {
    if (yearMounthFolders.length > 0) {
      // 選択肢を変更
      updateYearOptions(yearMounthFolders);
    }
  }, [yearMounthFolders]);

  useEffect(() => {
    if (yearOptions.length > 0) {
      updateMonthOptions(year, yearMounthFolders);
    }
  }, [yearOptions]);

  useEffect(() => {
    if (monthOptions.length > 0) {
      // 日付フォルダ取得
      getDayFolders(year, month, yearMounthFolders);
    }
  }, [monthOptions]);

  useEffect(() => {
    if (dayFolders.length > 0) {
      // 日付の選択肢を更新
      updateDayOptions(dayFolders);

      // 時間フォルダ取得
      getHourFolders(day, dayFolders);
    }
  }, [dayFolders]);

  useEffect(() => {
    if (hourFolders.length > 0) {
      updateHourOptions(hourFolders);

      // トレースファイル取得
      getTraceFiles(hour, hourFolders);
    }
  }, [hourFolders]);

  useEffect(() => {
    if (traceFiles.length > 0) {
      updateMinuteOptions(traceFiles);
    };
  }, [traceFiles]);

  useEffect(() => {
    if (traceFiles.length > 0) {
      for (const f of traceFiles) {
        // name: "yscc_trace_20241231_2350.csv"
        const opt = f.name.split("_").at(-1).substr(2, 2);

        const min = parseInt(opt);

        if (min === minute) {
          setSelectedTraceFile(f.key);
          break;
        }
      }
    }
  }, [traceFiles, minute]);

  useEffect(() => {
    onChange(selectedTraceFile);
  }, [selectedTraceFile]);

  return (
    <>
      <Flex width="100%" direction="column">
        <Flex width="100%" alignItems="flex-end" gap="6px">
          {/* 年 */}
          <SelectField
            label="日時"
            width="100%"
            value={year}
            onChange={(e) => {
              const val = parseInt(e.target.value);
              setYear(val);
              updateMonthOptions(val, yearMounthFolders);
            }}
          >
            {
              yearOptions.map((y) => {
                return (
                  <option key={y} value={y}>{y}</option>
                )
              })
            }
          </SelectField>
          <Flex paddingBottom="7px">/</Flex>
          {/* 月 */}
          <SelectField
            width="100%"
            value={month}
            onChange={(e) => {
              setMonth(parseInt(e.target.value));

              getDayFolders(year, parseInt(e.target.value), yearMounthFolders);
            }}
          >
            {
              monthOptions.map((m) => {
                return (
                  <option key={m} value={m}>{m}</option>
                )
              })
            }
          </SelectField>
          <Flex paddingBottom="7px">/</Flex>
          {/* 日 */}
          <SelectField
            width="100%"
            value={day}
            onChange={(e) => {
              const val = parseInt(e.target.value);
              setDay(val);
              getHourFolders(val, dayFolders);
            }}
          >
            {
              dayOptions.map((d) => {
                return (
                  <option key={d} value={d}>{d}</option>
                )
              })
            }
          </SelectField>
          <Flex></Flex>
          <SelectField
            width="100%"
            value={hour}
            onChange={(e) => {
              const val = parseInt(e.target.value);
              setHour(val);

              // トレースファイル取得
              getTraceFiles(val, hourFolders);
            }}
          >
            {
              hourOptions.map((h) => {
                return (
                  <option key={h} value={h}>{h}</option>
                )
              })
            }
          </SelectField>
          <Flex paddingBottom="7px">:</Flex>
          <SelectField
            width="100%"
            value={minute}
            onChange={(e) => {
              setMinute(parseInt(e.target.value));
            }}
          >
            {
              minuteOptions.map((m) => {
                return (
                  <option key={m} value={m}>{m}</option>
                )
              })
            }
          </SelectField>
        </Flex>
      </Flex>
    </>
  )
}

export default TraceForPlottingSelecter;
